// Headers
const header = document.querySelector(".header");
const headerTop = document.querySelector(".header__top");
const headerHeight = header.offsetHeight;

const progressBar = document.getElementById("progress-bar");

let processScroll = () => {
  let docElem = document.documentElement, 
  docBody = document.body,
  scrollTop = docElem['scrollTop'] || docBody['scrollTop'],
    scrollBottom = (docElem['scrollHeight'] || docBody['scrollHeight']) - window.innerHeight,
  scrollPercent = scrollTop / scrollBottom * 100 + '%';

  // console.log(scrollTop + ' / ' + scrollBottom + ' / ' + scrollPercent);

    if(progressBar){
      progressBar.style.setProperty("--scrollAmount", scrollPercent); 
      progressBar.style.setProperty("--scrollHeaderHeight", headerHeight); 
    }

}

document.addEventListener('scroll', processScroll);